import {useQuery} from "@tanstack/react-query";
import * as api from "../../../api";
import {useTranslation} from "react-i18next";


export const useStationRegistryQuery = () => {
    const {i18n} = useTranslation();
    const locale = i18n.language;

    return useQuery({
        queryKey: ['registry', 'station', locale],
        queryFn: () => api.Registry.getStationRegistry(locale),
        keepPreviousData: true,
        staleTime: 1000 * 60 * 60 * 24 * 7, // 1 week
    });
}